import { Purchase } from '@/core/domain/purchase/Purchase.types';
import {
  PurchaseItem,
  PurchaseItemsFormValues,
} from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { RequestPurchases } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.types';
import { FormInstance, Tabs } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import CofinsForm from '../CreateItemPurchase/CofinsForm';
import CreateItemPurchaseForm from '../CreateItemPurchase/General/index';
import GeneralTaskForm from '../CreateItemPurchase/GeneralTask';
import IcmsForm from '../CreateItemPurchase/IcmsForm';
import IiForm from '../CreateItemPurchase/IiForm';
import IpiForm from '../CreateItemPurchase/IpiForm';
import IrrpjAndCsllForm from '../CreateItemPurchase/IrrpjAndCsllForm';
import IssqnForm from '../CreateItemPurchase/IssqnForm';
import PisForm from '../CreateItemPurchase/PisForm';
import IcmsOperInterForm from './../CreateItemPurchase/IcmsOperInterForm/index';
import IbsCbsFormFields from '@/components/_common/TaxReform/IbsCbsFormFields';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
  purchase?: Purchase;
  isTask?: boolean;
  requestPurchase?: RequestPurchases;
  item?: PurchaseItem;
}

const PurchaseItemsFormTabs: React.FC<Props> = ({
  purchase,
  form,
  isTask,
  requestPurchase,
  item,
}) => {
  const intl = useIntl();

  return (
    <>
      <Tabs defaultActiveKey="general">
        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabOne.general',
          })}
          key="general"
        >
          {isTask ? (
            <GeneralTaskForm
              form={form}
              purchase={purchase}
              requestPurchase={requestPurchase}
              purchaseItem={item}
            />
          ) : (
            <CreateItemPurchaseForm
              form={form}
              purchase={purchase}
              requestPurchase={requestPurchase}
              purchaseItem={item}
            />
          )}
        </Tabs.TabPane>

        {isTask ? (
          <Tabs.TabPane
            tab={intl.formatMessage({
              id: 'purchases.items.task.issqn',
            })}
            key="issqn"
          >
            <IssqnForm form={form} />
          </Tabs.TabPane>
        ) : (
          <Tabs.TabPane
            tab={intl.formatMessage({
              id: 'purchases.items.part.tabTwo.icms',
            })}
            key="icms"
          >
            <IcmsForm form={form} />
          </Tabs.TabPane>
        )}

        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabThree.ipi',
          })}
          key="ipi"
        >
          <IpiForm form={form} />
        </Tabs.TabPane>

        {isTask && (
          <Tabs.TabPane
            tab={intl.formatMessage({
              id: 'purchases.items.task.irpjAndCsll',
            })}
            key="irpjAndCsll"
          >
            <IrrpjAndCsllForm form={form} />
          </Tabs.TabPane>
        )}

        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabFour.pis',
          })}
          key="pis"
        >
          <PisForm form={form} />
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabFive.cofins',
          })}
          key="cofins"
        >
          <CofinsForm form={form} />
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabSix.icmsOperInter',
          })}
          key="icmsOperInter"
        >
          <IcmsOperInterForm form={form} />
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={intl.formatMessage({
            id: 'purchases.items.part.tabSeven.iI',
          })}
          key="II"
        >
          <IiForm form={form} />
        </Tabs.TabPane>

        {/* <Tabs.TabPane tab="IS" key="is">
          <IsFormFields
            form={form}
            disabledFields={false}
            prefixPath={['purchaseItemTaxes']}
          />
        </Tabs.TabPane> */}

        <Tabs.TabPane tab="IBS/CBS" key="ibsCbs">
          <IbsCbsFormFields
            form={form}
            disabledFields={false}
            prefixPath={['purchaseItemTaxes']}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default PurchaseItemsFormTabs;
